module.exports = __webpack_public_path__ + "img/n_pg.3eb6e329.jpg";